<template>
    <div class="col-md-12 tab-one-wrapper">
        <!-- <div class="card-status-center">
            <group :queues="queues" :groups="groups" @selection-changed="updateChartFilter" />
        </div> -->
  
      <!-- <div class="card-status-center">
        <service-level :filter="chartFilter" />
      </div> -->
      <div class="row">
        <div class="card-status-center">
          <card-status />
        </div>
        <div class="col-md-7">
            <div class="row">
            <select class="form-control" name="queues" id="queueSelect" v-model="queueSelect">
                <option value="*">Todas as filas</option>
                <option v-for="q in queues" :key="q.id" :value="q.name">{{q.name}}</option>
            </select>
        </div>
          <div class="row">
            <card-realtime
                v-for="op in filteredOperators"
                :key="op.id"
                :nome="op.nome" 
                :id="op.id" 
                :extension="op.extension_line"
                :status="userStatus"
                :connection="connection"
                :userQueues="op.queues"
            ></card-realtime>
          </div>
        </div>
        <div class="col-md-5">
          <calls-queue :connection="connection" />
          <total-calls :connection="connection" />
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  import cardRealtime from './CardRealtime.vue';
  import cardStatus from './CardStatus.vue';
  import callsQueue from './CallsinQueue';
  import totalCalls from './TotalCalls';
  import group from '../filters/Group.vue';
  import serviceLevel from "../charts/ServiceLevelRealtime.vue";
  import io from 'socket.io-client';
  
  export default {
    components: { group, cardRealtime, cardStatus, callsQueue, totalCalls, serviceLevel },
    data() {
      return {
        operators: [],
        queues: [],
        groups: [],
        connection: null,
        queueStatus: [],
        chartFilter: "*",
        queueSelect: '*',
        filteredOperators: [],
        userStatus: 'Deslogado'
      }
    },
    methods: {
        groupQueues() {
            this.queueStatus = [];
        },
        async allQueues(){
            const { data } = await axios.get('/user/listQueueUser');
            if (data && data.length > 0) {
                this.queues = data;
            }
        },
      setupSocketConnection() {
        const parsedTelefone = (process.env.MIX_TELEFONE === 'true');
        if (parsedTelefone) {
          this.connection = io(`${location.protocol}//${location.hostname}:3007/realtimeModule`, {
            reconnection: true,
            reconnectionAttempts: Infinity,
            reconnectionDelay: 1000,
            reconnectionDelayMax: 5000,
            randomizationFactor: 0.5,
            pingTimeout: 300000, // 5 minutos
            pingInterval: 60000  // 1 minuto
          });
  
          this.connection.on('connect', () => {
            console.log('Conectado ao serviço do realtime');
          });
  
          this.connection.on('disconnect', (reason) => {
            console.log(`Desconectado: ${reason}`);
          });
  
          this.connection.on('reconnect_attempt', (attemptNumber) => {
            console.log(`Tentativa de reconexão #${attemptNumber}`);
          });
        } else {
          this.connection = {
            on: function () { },
            emit: function () { }
          };
        }
      },
      fetchQueuesAndGroups() {
        axios.get('/user/listQueueUser').then(({ data }) => {
          this.queues = data;
        });
  
        axios.get("/listGroups").then(response => {
          this.groups = response.data;
        }).catch(error => {
          console.error(error);
        });
      },
      updateChartFilter(newFilter) {
        this.chartFilter = newFilter;
      }
    },
    created() {
      this.setupSocketConnection();
      // this.fetchQueuesAndGroups();
  
      axios.get('/realtime/listUsersPhone').then(({ data }) => {
        this.operators = data;
        this.filteredOperators = data;
      });

      this.allQueues();
    },
    mounted() {
      this.connection.emit('QueueStatus');
    },
    watch: {
        queueSelect() {
            if(this.queueSelect != '*'){
                this.filteredOperators = this.operators.filter(el => {
                    return el.queues.some(queue => {
                        return queue.name.includes(this.queueSelect);
                    });
                });
            } else {
                this.filteredOperators = this.operators;
            }
            this.connection.emit('QueueStatus');
        }
    }
  }
  </script>

<style scoped>
.card-status-center{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

#queueSelect{
    width: 200px !important
}

</style>